import { useQuery } from 'react-query';
import { QUERY_STALE_TIME } from 'config';
import DocumentTypesAPI from './api';

export function useGetDocTypes(preventTypes?: string[]) {
  return useQuery(
    ['document_types', preventTypes],
    (key) => DocumentTypesAPI.getDocTypes(preventTypes),
    {
      staleTime: QUERY_STALE_TIME,
    }
  );
}
